import { Step } from 'react-joyride';

import { HOME_TOUR_CLASSES } from './classNames';

export const homeSteps: Step[] = [
  {
    target: `.${HOME_TOUR_CLASSES.PROFILE_BUTTON}`,
    title: 'Set your profile',
    content:
      'Here you can set your general, financial, and background information.',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${HOME_TOUR_CLASSES.ESTIMATED_TIMELINE}`,
    title: 'Timeline Overview',
    content: 'This is the estimated timeline for you to open the unit.',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${HOME_TOUR_CLASSES.SEARCHING_USERS}`,
    title: 'Searching Users',
    content:
      'This is the list of users currently searching for units in your area.',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${HOME_TOUR_CLASSES.CURRENT_DISCOVERY_STEP}`,
    title: 'User Journey',
    content:
      'Here you can see the current stage you are at in the process of opening your unit.',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${HOME_TOUR_CLASSES.REFER_BUTTON}`,
    title: 'Task Action Button',
    content:
      "Click this button to perform the task action - whether it's viewing a document, joining a meeting, or watching a video. You'll need to complete this action before marking the task as done.",
    placement: 'left',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${HOME_TOUR_CLASSES.STAGE_ITEM_CHECKBOX}`,
    title: 'Task Completion',
    content:
      'After completing the task action, check this box to mark the task as done. This helps track your progress through the discovery process.',
    placement: 'right',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${HOME_TOUR_CLASSES.LIKED_TERRITORIES}`,
    title: 'Liked Territories',
    content: 'Here you can see the territories you have liked.',
    placement: 'bottom',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${HOME_TOUR_CLASSES.AIMEI_CHAT_BOX}`,
    title: 'Aimei Chat Box',
    content:
      'Aimei is your personal assistant. You can ask her questions about your unit, the process, the FDD, and more.',
    placement: 'top',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${HOME_TOUR_CLASSES.SIDEBAR_HOME_BUTTON}`,
    title: 'Home Navigation',
    content:
      'Click here to return to your dashboard home page with overview information and key metrics.',
    placement: 'right',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${HOME_TOUR_CLASSES.SIDEBAR_DISCOVERY_PARENT_BUTTON}`,
    title: 'Discovery Process',
    content:
      'Access your franchise discovery journey with structured stages and tasks to guide you through the process.',
    placement: 'right',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${HOME_TOUR_CLASSES.SIDEBAR_DISCOVERY_STAGE_1_BUTTON}`,
    title: 'Discovery Stages',
    content:
      'Navigate through individual discovery stages. Each stage contains specific tasks and information relevant to that phase of your journey.',
    placement: 'right',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${HOME_TOUR_CLASSES.SIDEBAR_TERRITORIES_BUTTON}`,
    title: 'Territory Explorer',
    content:
      'Explore available territories, view demographics, and manage your territory preferences and reservations.<br/><br/><small><em>Note: If this feature is locked, you must advance through the Discovery Process first.</em></small>',
    placement: 'right',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${HOME_TOUR_CLASSES.SIDEBAR_FINANCIAL_OVERVIEW_BUTTON}`,
    title: 'Financial Planning',
    content:
      'Access financial projections, investment requirements, and financial planning tools for your franchise.<br/><br/><small><em>Note: If this feature is locked, you must advance through the Discovery Process first.</em></small>',
    placement: 'right',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${HOME_TOUR_CLASSES.SIDEBAR_LIBRARY_BUTTON}`,
    title: 'Document Library',
    content:
      'Access important documents, contracts, franchise materials, and your document library.<br/><br/><small><em>Note: If this feature is locked, you must advance through the Discovery Process first.</em></small>',
    placement: 'right',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${HOME_TOUR_CLASSES.SIDEBAR_ASK_AIMEI_BUTTON}`,
    title: 'AI Assistant',
    content:
      'Get instant answers and guidance from Aimei, your AI-powered franchise assistant.<br/><br/><small><em>Note: If this feature is locked, you must advance through the Discovery Process first.</em></small>',
    placement: 'right',
    disableBeacon: true,
    spotlightClicks: true,
  },
  {
    target: `.${HOME_TOUR_CLASSES.SIDEBAR_QUICK_LINK_1_BUTTON}`,
    title: 'Quick Links',
    content:
      'Access frequently used external resources and tools that have been configured for your franchise.',
    placement: 'right',
    disableBeacon: true,
    spotlightClicks: true,
  },
];
